import React, { useCallback, useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const SCROLL_FRACTION = 0.75;

/**
 * Translucent up/down chevrons on mobile when more content remains
 * above or below the viewport (public emergency page).
 */
function PublicScrollHints({ hasBottomChrome = false }) {
  const [showUp, setShowUp] = useState(false);
  const [showDown, setShowDown] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => {
      if (!mq.matches) {
        setShowUp(false);
        setShowDown(false);
        return;
      }
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const viewport = window.innerHeight;
      const full = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
      );
      const bottomPad = hasBottomChrome ? 96 : 72;
      setShowUp(scrollTop > 48);
      setShowDown(scrollTop + viewport < full - bottomPad);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    mq.addEventListener?.("change", update);
    const id = window.setInterval(update, 800);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      mq.removeEventListener?.("change", update);
      window.clearInterval(id);
    };
  }, [hasBottomChrome]);

  const scrollByPage = useCallback((direction) => {
    const amount = Math.round(window.innerHeight * SCROLL_FRACTION);
    window.scrollBy({ top: direction * amount, behavior: "smooth" });
  }, []);

  if (!showUp && !showDown) return null;

  return (
    <div
      className={`pub-scroll-hints pub-scroll-hints--dock${hasBottomChrome ? " pub-scroll-hints--owner" : ""}`}
    >
      {showUp && (
        <button
          type="button"
          className="pub-scroll-hints__chip pub-scroll-hints__chip--up"
          onClick={() => scrollByPage(-1)}
          aria-label="Scroll up"
        >
          <ChevronUp size={22} strokeWidth={2.5} />
        </button>
      )}
      {showDown && (
        <button
          type="button"
          className="pub-scroll-hints__chip pub-scroll-hints__chip--down"
          onClick={() => scrollByPage(1)}
          aria-label="Scroll down"
        >
          <ChevronDown size={22} strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
}

export default PublicScrollHints;
